import styled from 'styled-components';

export const TollTipButton = styled.span`
  position: relative;
  cursor: pointer;
  ::after {
    content: 'i';
    border-radius: 50%;
    width: 14px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: white;
    border-color: white;
    border-width: 1px;
    cursor: pointer;
    border-style: solid;
  }
`;

export const TollTipContent = styled.div`
  position: absolute;
  z-index: 999;
  min-width: 100px;
  min-height: 20px;
  padding: 10px;
  border-radius: 6px;
  background-color: #2D4557;
  transform: translateX(-50%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;
